export const API_BASE_URL: string = 'https://api.smart-tx.io/';
export const API_METHOD_LOGIN: string = 'login';
export const API_METHOD_LOST_PASSWORD: string = 'lostPassword';
export const API_METHOD_CHANGE_PASSWORD: string = 'password';
export const API_METHOD_REGISTER: string = 'register';
export const API_METHOD_DEVICES: string = 'devices';
export const API_METHOD_PUSH_DEVICES: string = 'pushdevices';
export const API_METHOD_SITES: string = 'sites';
export const API_METHOD_SYNC: string = 'sync';
export const API_METHOD_UPDATE: string = 'update';
export const API_METHOD_FIRMWWARE: string = 'firmwares';
export const API_METHOD_LOG_EVENTS: string = 'logevents';
export const API_METHOD_USERS: string = 'users';
export const API_METHOD_ALARMS: string = 'alarms';
// export const API_METHOD_CONTROL: string = 'control';
export const API_METHOD_CHANNEL: string = 'channel';
export const API_METHOD_RECIPIENT: string = 'recipients';
export const API_METHOD_SCHEDULE: string = 'thermostat-schedule';
export const API_METHOD_RECIPIENT_TEST: string = 'test';
export const API_CREDENTIALS: any = 'include';
export const API_HEADERS: any = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
};
export const API_VERB_POST: any = 'POST';
export const API_VERB_DELETE: any = 'DELETE';
export const API_VERB_PUT: any = 'PUT';
export const API_VERB_GET: any = 'GET';


// WEBPACK FOOTER //
// ./src/actions/API.tsx